import React, { Component } from 'react';
import { action } from 'mobx';
import 'Styles/commonComponents/FiltersPanel/FiltersPanel.scss';
import FiltersStore from 'Stores/StopList/FiltersStore';
import AppStore from 'Stores/AppStore';
import { observer } from 'mobx-react'
import FilterBlockDateTimeRange from "Components/Common/FiltersPanel/FilterBlockDateTimeRange";
import FilterBlockListItems from "Components/Common/FiltersPanel/FilterBlockListItems";
import CheckboxWithText from "Components/Common/CheckboxWithText";
import 'Styles/filterProtocolOrDocument.scss';

class FiltersPanel extends Component {

    constructor() {
        super();
    }

    render() {
        return (
            <div className='filter-panel'>
                <div
                    id="regnum-alias-content"
                    className={FiltersStore.filtersRender.includeInitiative ? " disabled" : ""}
                >
                    <span>{AppStore.isMeeting ? 'Рег. №' : 'Рег. № РК/РКПД'}</span>
                    <input
                        id='filter-regnum-alias'
                        placeholder='Введите рег. номер'
                        className='regnum-input-placeholder-color'
                        onChange={event => FiltersStore.filtersRender.regNumAlias = event.target.value}
                        value={FiltersStore.filtersRender.regNumAlias}
                    />
                </div>

                <CheckboxWithText
                    className={FiltersStore.filtersRender.includeInitiative ? " disabled" : ""}
                    checked={FiltersStore.filtersRender.matchWholeWord}
                    onChange={(checked) => FiltersStore.filtersRender.matchWholeWord = checked}
                    text="Строгое соответствие"
                />
                {AppStore.isMeeting ? null :
                    <CheckboxWithText
                        checked={FiltersStore.filtersRender.includeInitiative}
                        onChange={action((checked) => {
                            FiltersStore.filtersRender.includeInitiative = checked;
                            if (checked) {
                                FiltersStore.filtersRender.regNumAlias = '';
                                FiltersStore.filtersRender.matchWholeWord = false;
                                FiltersStore.filtersRender.regDateStart = null;
                                FiltersStore.filtersRender.regDateEnd = null;
                            }
                        })}
                        text="Инициативное поручение"
                    />
                }

                <FilterBlockDateTimeRange
                    className="filter-reg-date"
                    title="Дата регистрации в СЭД"
                    disabled={FiltersStore.filtersRender.includeInitiative}
                    getValueFrom={() => FiltersStore.filtersRender.regDateStart}
                    setValueFrom={value => FiltersStore.filtersRender.regDateStart = value}
                    getValueTo={() => FiltersStore.filtersRender.regDateEnd}
                    setValueTo={value => FiltersStore.filtersRender.regDateEnd = value}
                    getRenderStore={() => FiltersStore.renderStore.datesReg}
                    setRenderStore={val => FiltersStore.renderStore.datesReg = val}
                    getMinDate={() => AppStore.isMeeting
                        ? FiltersStore.filtersValues.meetingMinValueRegDate
                        : FiltersStore.filtersValues.docMinValueRegDate}
                    timeVisible={false}
                />

                <FilterBlockListItems
                    className="filter-users"
                    title="Пользователи"
                    listItems={FiltersStore.filtersValues.users}
                    value={FiltersStore.filtersRender.userIds}
                    setValue={val => FiltersStore.filtersRender.userIds = val}
                    getRenderStore={() => FiltersStore.renderStore.users}
                    setRenderStore={val => FiltersStore.renderStore.users = val}
                    emptyText="Нет данных"
                    emptySearchText="Совпадений нет"
                />

                <FilterBlockDateTimeRange
                    className="filter-error-date"
                    title="Дата и время ошибки"
                    getValueFrom={() => FiltersStore.filtersRender.errorDateStart}
                    setValueFrom={value => FiltersStore.filtersRender.errorDateStart = value}
                    getValueTo={() => FiltersStore.filtersRender.errorDateEnd}
                    setValueTo={value => FiltersStore.filtersRender.errorDateEnd = value}
                    getRenderStore={() => FiltersStore.renderStore.datesError}
                    setRenderStore={val => FiltersStore.renderStore.datesError = val}
                    timeVisible={true}
                    isTop={true}
                    getMinDate={() => AppStore.isMeeting
                        ? FiltersStore.filtersValues.meetingMinValueErrorDate
                        : FiltersStore.filtersValues.docMinValueErrorDate}
                />
            </div>
        )
    }
}

export default observer(FiltersPanel);